import { render } from "./Collapses.vue?vue&type=template&id=ccd48db0"
import script from "./Collapses.vue?vue&type=script&lang=js"
export * from "./Collapses.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__